import React from "react";
import style from "./ReadOnlyBanner.module.scss";
import constants from "../../../constants/constants.json";

export const ReadOnlyBanner = () => {
  return (
    <div className={style.read_only_block}>
      <div className={`alert alert-warning ${style.read_only_banner}`}>
        <i className="fa fa-eye mr-2" />
        {constants.assessment.readOnlyBanner}
      </div>
    </div>
  );
};
